import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MPGroupsHomePage } from './mp-groups-home.page';
import { PagesModule } from '../../pages.module';


const routes: Routes = [
  {
    path: '',
    component: MPGroupsHomePage
  }
];

@NgModule({
  imports: [
    PagesModule,
    RouterModule.forChild(routes)
  ],
  declarations: [MPGroupsHomePage]
})
export class MPGroupsHomePageModule { }
